import restoreScroll from 'redux-first-router-restore-scroll'
import { onBeforeChange, onAfterChange } from './thunks/index'

export default {
  restoreScroll: restoreScroll(),
  onBeforeChange,
  onAfterChange,
}



// WEBPACK FOOTER //
// ./src/routing/options.js